(function () {
  /**
   * @ngdoc module
   * @name akitabox.directives.headerHider
   */
  angular
    .module("akitabox.mobile.directives.headerHider", [])
    .directive("abmHeaderHider", AbmHeaderHider);

  /**
   * @ngdoc directive
   * @module akitabox.directives.headerHider
   * @name AbmHeaderHider
   * @restrict A
   * @description
   * `abm-header-hider` hides the mobile header when directive element is scrolled
   */
  /* @ngInject */
  function AbmHeaderHider($timeout, Utils) {
    return {
      restrict: "A",
      link: postLink,
    };

    function postLink($scope, $element, attrs) {
      // Constants
      var SHRINK_SPEED = 0.5;
      var TRANSFORM_PROP = Utils.vendor.getProperty("transform");

      // UI Elements
      var $content;
      var $header;
      var $tabs;

      // Previous position scrolled from
      var prevPosition = 0;
      // Shrinking element's height
      var elementHeight = 0;
      // Scrolling element is a tab content
      var isTabContent = false;

      // Functions
      var debouncedUpdateHeight = angular.debounce(updateHeight, 5 * 1000);
      var throttledOnScroll = Utils.throttle(Utils.onScroll(onScroll, false));

      $timeout(function () {
        init();
      });
      /**
       * Initialize scroll shrink
       */
      function init() {
        // Get UI elements
        var $parent = $element.parent();
        $content = getContent($parent);
        $header = getHeader();

        // resetting the header position when changing routes
        $scope.$on("$stateChangeStart", function (event) {
          $header.css("transform", "translateY(0px)");
        });

        $element.css("transition", "transform 0.2s");

        // Verify content exists
        if ($content) {
          // Get element height
          updateHeight();
          // Get the current scroll position
          prevPosition = $content[0].scrollTop;
          // Attach throttled scroll listener
          angular.element($content).on("scroll", throttledOnScroll);
        }
      }

      /**
       * Handle scroll event
       *
       * @param  {Object} $event Scroll event
       */
      function onScroll($event, currentPosition) {
        // Attempt to update element height
        debouncedUpdateHeight();

        var threshold = elementHeight * 2.5;
        var distance = Math.abs(currentPosition - prevPosition);
        var scrollingDown = currentPosition > prevPosition;

        // Collapse if scrolling down and the user has scrolled
        // more than double the height of the shrinking element
        if (scrollingDown && currentPosition > threshold) collapse();
        // Expand if not scrolling down and the scrolled distance
        // is not equal to the height of the shrinking element
        else if (distance !== elementHeight) expand();

        // Save current position
        prevPosition = currentPosition;
      }

      /**
       * Move elements
       *
       * @param  {Number} d Distance
       */
      function moveElements(d) {
        // Detemine the distance the elements should be moved to from their original positions
        d = (0 - d) * SHRINK_SPEED;

        // Build translation value for shrinking element and followers
        var translation = buildTranslation(d);

        // Negative margin to "add" to the scrolling content
        var margin = d + "px";

        // Set shrinking element attributes
        $element.css(TRANSFORM_PROP, translation);

        // Transform content if not in a tab
        if (!isTabContent) $content.css(TRANSFORM_PROP, translation);

        // Transform header
        angular.forEach($header, function ($follower) {
          angular.element($header).css(TRANSFORM_PROP, translation);
        });

        // Set scrolling content margin
        if (isTabContent) {
          $tabs.css("margin-bottom", margin);
        } else {
          $content.css("margin-bottom", margin);
        }
      }

      function collapse() {
        moveElements(elementHeight / SHRINK_SPEED);
        // Update toggle attribute
        if (angular.isDefined(attrs.abmIsOpen)) {
          Utils.setNamespacedValue($scope, attrs.abmIsOpen, false);
        }
      }

      function expand() {
        moveElements(0);
        // Update toggle attribute
        if (angular.isDefined(attrs.abmIsOpen)) {
          Utils.setNamespacedValue($scope, attrs.abmIsOpen, true);
        }
      }

      /**
       * Build a translate 3D style property value
       *
       * @param  {Number} d   Distance to translate
       * @return {String}     Property value
       */
      function buildTranslation(d) {
        return "translateY(" + d + "px)";
      }

      /**
       * Update element height
       */
      function updateHeight() {
        elementHeight = $header.prop("offsetHeight");
      }

      /**
       * Get content that will be scrolled
       *
       * @param  {Object} $parent     Parent element
       * @return {Object}             Angular element
       */
      function getContent($parent) {
        // Find md-virtual-repeat
        var virtualRepeat = $parent.find("md-virtual-repeat-container");
        if (virtualRepeat.length > 0)
          return angular.element(virtualRepeat[0].children[0]);
        // Find md-tab-content
        var tabContents = $parent.find("md-tab-content");
        if (tabContents.length > 0) {
          isTabContent = true;
          $tabs = $parent.find("md-tabs");
          return tabContents;
        }
        // Find md-content
        var content = $parent.find("md-content");
        if (content.length > 0) return content;
        // Neither md-content, md-tab-content, nor md-virtual-repeat-container was found
        return null;
      }

      /**
       * Get app header
       *
       * @return {Object}     Angular element
       */
      function getHeader() {
        var elements = angular.element(
          document.querySelectorAll("abx-app-header")
        );
        angular.forEach(elements, function (elem) {
          angular.element(elem).css("transition", "transform 0.2s");
        });
        return elements;
      }
    }
  }
})();
